import React from 'react';
import { Card, Button } from 'react-bootstrap';

function MaintenancePage() {
    return (
        <div className="maintenance-page">
            <div className="maintenance-page-content">
                <Card className="questionnaire-card p-4 shadow-sm text-center">
                    <Card.Body>
                        <div className="maintenance-icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                            </svg>
                        </div>
                        <Card.Title className="questionnaire-card-title h3 mb-3">Scheduled Maintenance</Card.Title>
                        <Card.Text className="text-muted mb-4">
                            The ISOQAR Questionnaire is currently undergoing scheduled maintenance.
                            We apologise for any inconvenience and expect to be back online shortly.
                        </Card.Text>
                        <div className="maintenance-refresh-button d-grid">
                            <Button variant="primary" onClick={() => window.location.reload()}>
                                Try Again
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default MaintenancePage;

